const convertMinutesToString = (minutesAmount: number): string => {
  const hours = Math.floor(minutesAmount / 60);

  const minutes = minutesAmount % 60;

  return `${hours} год ${minutes} хв`;
};

const getIndexFromAutoapproveListPath = (path: string): number | null => {
  const start = path.indexOf('[');
  const end = path.indexOf(']');

  if (start < 0 || end < 0) {
    return null;
  }

  const index = parseInt(path.slice(start + 1, end), 10);

  return index;
};

export const helper = {
  convertMinutesToString,
  getIndexFromAutoapproveListPath,
};
